import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TextField from "@mui/material/TextField";
import moment from "moment";
import CircularIndeterminate from "../GeneralComponents/CirularProgress";
import StyledDataGrid from "../GeneralComponents/StyledDataGrid";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import { useGlobalContext } from "../../../context";
import swal from "sweetalert";
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

import "../../../assets/css/DG.css";
import "../../../assets/css/AccordionStyle.css";
import * as Io from "react-icons/io";
import { Checkbox, FormControlLabel, FormGroup, IconButton, Modal, Tooltip } from "@mui/material";
import Dropdown from "./DropDown";
import Cookies from "universal-cookie";
import OnlineInvoicePreview from "./OnlineInvoicePreview";

function OnlineInvoices() {
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setpageNumber] = useState(1);
    const [inoviceTotal, setInoviceTotal] = useState(0);
    const [inoviceNumberOfPages, setInoviceNumberOfPages] = useState(0);

    const { loading, onlineInvoices, exportToCSV, clearPointsAdvanceSearchFields, fetchData, sendAccepted, sendRejected, sendRequest, getUsers } = useGlobalContext();

    const [scheduleDate, setScheduleDate] = useState(null);
    const [fromDate, setFormDate] = useState(null);
    const [toDate, setTODate] = useState(null);
    const [request, setRequested] = useState(null);
    const [accepted, setAccepted] = useState(null);
    const [rejected, setRejected] = useState(null);
    const [open, setOpen] = useState(false);
    const [usersData, setUsersData] = useState([]);
    const [selected, setSelected] = useState("");
    const [selectedInvoice, setSelectedInvoice] = useState([]);
    const cookies = new Cookies();
    const userId = cookies.get("user_id");
    const [showDetails,setShowDetails] = useState(false)
    const [selectedObject, setSelectedObject] = useState(null);
    const formatDate = (date) => {
        var d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [year, month, day].join("-");
    };

    const [accExpansion, setAccExpansion] = useState(false);

    const handleExpansion = (expansion) => setAccExpansion(expansion);

    const handlePageChange = (newPage) => {
        setpageNumber(newPage + 1);
    };

    const advanceSearch = async (type = "BROWSING") => {
        let params = {
            page: type === "SEARCH" ? 1 : pageNumber,
            page_size: pageSize,
        };
        if (fromDate) {
            params = {
                ...params,
                creation_date_from: formatDate(fromDate),
            };
        }
        if (toDate) {
            params = {
                ...params,
                creation_date_to: formatDate(toDate),
            };
        }
        var statuses=[];
        if (request) {// represnt created/approved invoices
            statuses.push("CREATED")
            statuses.push("APPROVED")
        }
        if (accepted) {//represnt deposited
            statuses.push("DEPOSITED")
        }
        if (rejected) { // represnt rejected requested
            statuses.push("DECLINED")
        }
        if(statuses&&statuses?.length){
               params = {
                ...params,
                statuses: statuses,
            };
        }
        const fetchedData = await fetchData("ONLINE_INVOICES", "online_invoices", {
            ...params,
        });
        return fetchedData;
    };

    const handleClose = () => {
        setOpen(false);
    };

    const gettingUsers = async () => {
        let users = await getUsers();
        let filteredDate = await users?.data?.filter((user) => user?.id !== parseInt(userId) && user?.department.id === 2);
        setUsersData(users.data);
        // setUsersData(filteredDate);
    };

    useEffect(() => {
        // fetchData("INVOICES", "my_all_invoices_for_user");
        // gettingUsers();
        advanceSearch();
    }, [pageSize, pageNumber]);

    //Reformatting points object once points are loaded
    useEffect(() => {
        if (onlineInvoices && onlineInvoices.data && onlineInvoices.data.length > 0) {
            const reformatVisits = onlineInvoices.data.map((rowVisit) => {
                return {
                    ...rowVisit,
                    userId: userId,
                };
            });
            setRow(reformatVisits);
            setInoviceTotal(onlineInvoices.total);
            setInoviceNumberOfPages(onlineInvoices.last_page);
        } else {
            setRow([]);
            setInoviceTotal(0);
            setInoviceNumberOfPages(0);
        }
    }, [onlineInvoices]);

    const [rows, setRow] = useState([]);
    const [columns] = useState([
        { field: "id", headerName: "ID", minWidth: 80,maxWidth:80 },
        {
            field: "name",
            headerName: "Customer_name",
            minWidth: 250,
            renderCell: (rows) => (
                <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                    <span>{rows?.row?.point?.name}</span>
                </div>
            ),
        },
        {
            field: "invoice_number",
            headerName: "Invoice Number",
            minWidth: 120,
            renderCell: (rows) => (
                <div
                    style={{
                        width: "100%",
                        overflowWrap: "break-word",
                        wordWrap: "break-word",
                        hyphens: "auto",
                        whiteSpace: "normal", //this is the one that gets you all the time,
                        display: "flex",
                        flexWrap: "wrap",
                        // inlineSize: '299px',
                    }}>
                    {rows.row.invoice_number}
                    <br />
                </div>
            ),
        },
        {
            field: "ammount",
            headerName: "Original Bill Amount",
            minWidth: 150,
            maxWidth:150,
            renderCell: (rows) => (
                <div style={{ width: "100%" }}>
                    {rows?.row?.currency+" "}
                    {rows.row.amount}
                    <br />
                </div>
            ),
        },
        {
            field: "new_amount",
            headerName: "Paid Amount",
            minWidth: 150,
            maxWidth:150,
            renderCell: (rows) => (
                <div style={{ width: "100%" }}>
                    {rows?.row?.currency+" "}
                    {rows.row.new_amount}
                    <br />
                </div>
            ),
        },
        {
            field: "status",
            headerName: "Payment Status",
            minWidth: 150,
            maxWidth:150,
            renderCell: (rows) => {
                let status = rows.row.payment_master?.status;
                let color = "";
                
                switch(rows.row.payment_master?.status) {
                    case "CREATED":
                        color = "#2196f3"; // Blue
                        break;
                    case "DEPOSITED":
                        color = "#4caf50"; // Green
                        break;
                    case "DECLINED":
                        color = "#f44336"; // Red
                        break;
                    default:
                        status = "-----";
                        color = "#757575"; // Grey
                }

                return (
                    <div style={{ 
                        width: "100%",
                        color: color,
                        fontWeight: "bold"
                    }}>
                        {status}
                    </div>
                );
            }
        },
        {
            field: "creation_source",
            headerName: "Creation Source",
            minWidth: 125,
            maxWidth:125,
            renderCell: (rows) => (
                <div style={{ width: "100%", display: "flex" }}>
                    <span> {rows.row.creation_source}</span>
                </div>
            ),
        },
        {
            field: "visit_id",
            headerName: "Visit ID",
            minWidth: 100,
            maxWidth:100,
            renderCell: (rows) => (
                <div style={{ width: "100%", display: "flex" }}>
                    <span> {rows.row.visit_id}</span>
                </div>
            ),
        },
        {
            field: "created_at",
            headerName: "Creation Date",
            minWidth: 150,
            renderCell: (rows) => (
                <div style={{ width: "100%" }}>
                    {rows.row.created_at
                        ? moment(rows.row.created_at).format("YYYY-MM-DD HH:mm:ss")
                            ? moment(rows.row.created_at).format("YYYY-MM-DD HH:mm:ss")?.slice(0, 10)
                            : null
                        : null}
                    <br />
                    {rows.row.created_at
                        ? moment(rows.row.created_at).format("YYYY-MM-DD HH:mm:ss")
                            ? moment(rows.row.created_at).format("YYYY-MM-DD HH:mm:ss")?.slice(10, 18)
                            : null
                        : null}
                </div>
            ),
        },
        { field: 'actions',flex: 1,
            headerName: 'Actions',                
            renderCell: (rows) => (
              <strong>                
                <IconButton  
                    style={{ marginLeft: 15 }}
                    aria-label="view" 
                    size="small" 
                    onClick={() => {                                   
                    previewObject(rows.row)
                    // previewObject(rows.row.object1)
                    }}>
                    <Tooltip title="View">
                        <RemoveRedEyeRoundedIcon color="primary" />
                    </Tooltip>
                </IconButton>                                                
              </strong>
            ),
        },   
    ]);
    const previewObject = async (object) => {
        setSelectedObject(object)
        setShowDetails(true)
    }
    const handelChangeDate = (date, number) => {
        if (number == 1) {
            setFormDate(date);
        } else if (number == 2) {
            setTODate(date);
        } else {
            setScheduleDate(date);
        }
    };

    const getDataForExported = async () => {
        let data = {
            page_size: inoviceTotal,
        };

        if (scheduleDate) {
            data = {
                ...data,
                schedule_date: formatDate(scheduleDate),
            };
        }
        if (fromDate) {
            data = {
                ...data,
                creation_date_from: formatDate(fromDate),
            };
        }
        if (toDate) {
            data = {
                ...data,
                creation_date_to: formatDate(toDate),
            };
        }
        const fetchedData = await fetchData("INVOICES", "my_all_invoices_for_user", {
            ...data,
        });
        return fetchedData;
    };

    const exportDataTOExcel = async () => {
        let data = await getDataForExported();
        var arr = [];
        if (data) {
            data?.data &&
                data?.data?.length > 0 &&
                data?.data?.map((itm) => {
                    arr.push({
                        Id: itm?.id,
                        User_Name: itm?.created_by?.full_name,
                        Customer_Name: itm?.point?.name,
                        Bill_type: itm?.bill_type,
                        Bill_number: itm?.bill_number,
                        Bayan: itm?.bayan,
                        Creation_Date: itm?.created_at ? moment(itm.created_at).format("YYYY-MM-DD HH:mm:ss") : null,
                    });
                });
        }
        exportToCSV(arr, "Invoices");
    };
    const handleClear=()=>{
        clearPointsAdvanceSearchFields()
        setFormDate(null)
        setTODate(null)
        setAccepted(false)
        setRequested(false)
        setRejected(false)
    }
    return (
        <>
            {showDetails?
                <OnlineInvoicePreview invoice={selectedObject} show={showDetails} setShow={()=>setShowDetails(false)} />
            :null}
            <Box display='flex'>
                {/* <Button
                    display='flex'
                    startIcon={<FileDownloadIcon />}
                    variant='contained'
                    sx={{ marginRight: 1, marginBottom: accExpansion ? "0" : "20px" }}
                    onClick={exportDataTOExcel}>
                    Export
                </Button> */}
                <Accordion display='flex' sx={{ flexGrow: 4 }} onChange={(event, expansion) => handleExpansion(expansion)}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />} aria-controls='panel1a-content' id='panel1a-header'>
                        <Typography>Advance Search</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box component='span' display='flex' bgcolor='white' flexDirection='column' sx={{ borderRadius: 1 }}>
                            <Box sx={{ m: 1 }} component='span' display='flex' bgcolor='white' flexDirection='row'>
                                <Box display='flex' sx={{ flexGrow: 2, alignItems: "center" }}>
                                    <Box
                                        sx={{
                                            width: "50%",
                                            ml: 1,
                                            mr: 2,
                                            pr: 2,
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                label='From Date'
                                                inputFormat='MM/DD/YYYY'
                                                value={fromDate}
                                                onChange={(date) => handelChangeDate(date, 1)}
                                                renderInput={(params) => <TextField {...params} style={{ width: "50%" }} />}
                                            />
                                            <Box style={{ width: "10%" }}></Box>
                                            <DesktopDatePicker
                                                label='to Date'
                                                inputFormat='MM/DD/YYYY'
                                                value={toDate}
                                                onChange={(date) => handelChangeDate(date, 2)}
                                                renderInput={(params) => <TextField {...params} style={{ width: "50%" }} />}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                    <FormGroup sx={{ flexDirection: "row", gap: 2 }}>
                                        <FormControlLabel
                                            control={<Checkbox checked={request} />}
                                            label={<Typography style={{ color: "black" }}>CREATED / APPROVED</Typography>}
                                            onChange={() => {
                                                setRequested(!request);
                                            }}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={accepted} />}
                                            label={<Typography style={{ color: "black" }}>DEPOSITED</Typography>}
                                            onChange={() => {
                                                setAccepted(!accepted);
                                            }}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={rejected} />}
                                            label={<Typography style={{ color: "black" }}>DECLINED</Typography>}
                                            onChange={() => {
                                                setRejected(!rejected);
                                                // setRejected(null);
                                            }}
                                        />
                                    </FormGroup>
                                </Box>

                                <Box display='flex' sx={{ flexGrow: 1 }}>
                                    <Button variant='contained' spacing={2} sx={{ flexGrow: 1, margin: 1 }} onClick={() => advanceSearch("SEARCH")}>
                                        Search
                                    </Button>
                                    <Button
                                        variant='contained'
                                        spacing={2}
                                        sx={{ flexGrow: 1, margin: 1 }}
                                        color='secondary'
                                        onClick={handleClear}>
                                        Clear
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </AccordionDetails>
                </Accordion>
            </Box>

            <Box
                sx={{
                    height: "calc(100% - 9em)",
                    "& .MuiDataGrid-menuIcon,& .MuiDataGrid-iconButtonContainer,& .MuiDataGrid-columnSeparator": {
                        display: "none !important",
                    },
                }}>
                <StyledDataGrid
                    rows={rows}
                    columns={columns}
                    rowCount={inoviceTotal}
                    pageSize={pageSize}
                    page={pageNumber - 1}
                    onPageSizeChange={(newPageSize) => {
                        setPageSize(newPageSize);
                    }}
                    rowsPerPageOptions={[5, 10, 20]}
                    paginationMode='server'
                    onPageChange={(params) => {
                        handlePageChange(params);
                    }}
                    hideIconeInHeader={true}
                />
                <Box width='45%' m='auto'>
                    <Pagination
                        color='primary'
                        size='large'
                        count={inoviceNumberOfPages}
                        page={pageNumber}
                        showFirstButton
                        showLastButton
                        onChange={(e, p) => {
                            setpageNumber(p);
                        }}
                    />
                </Box>
                <div
                    style={{
                        width: "50%",
                        position: "absolute",
                        top: "100px",
                        margin: "0 auto",
                        left: "50%",
                        top: "50%",
                    }}>
                    {loading && <CircularIndeterminate />}
                </div>
                <Modal onClose={handleClose} open={open} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Box
                        sx={{
                            width: 400,
                            height: 100,
                            bgcolor: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-around",
                            borderRadius: "8px",
                        }}>
                        <Button
                            onClick={() => {
                                if (!selected) {
                                    swal("يرجى اختيار مستخدم");
                                } else {
                                    sendRequest(selectedInvoice, selected);
                                    setOpen(false);
                                }
                            }}
                            style={{
                                backgroundColor: "#2C74B3",
                                height: 50,
                            }}>
                            <Io.IoIosRepeat size={24} color={"#fff"} />
                        </Button>
                        <Dropdown users={usersData} selected={selected} setSelected={setSelected} />
                    </Box>
                </Modal>
            </Box>
        </>
    );
}

export default OnlineInvoices;
